module.exports = __webpack_public_path__ + "static/media/avatar.ca3eb194.gif";